// src/pages/AdminDashboard.js
import React from "react";
import { Link } from "react-router-dom";

export default function AdminDashboard() {
  const adminTools = [
    {
      title: "Add & Edit Shifts",
      path: "/admin/shifts",
      img: "https://img.icons8.com/ios-filled/100/f43f5e/calendar.png",
      description: "Create, assign, or edit shifts for workers."
    },
    {
      title: "Edit Timesheets & Payslips",
      path: "/admin/timesheets",
      img: "https://img.icons8.com/ios-filled/100/4b5563/task.png",
      description: "Manage, approve, and correct timesheets and payslips."
    },
    {
      title: "Create / Edit / View Invoices",
      path: "/admin/invoices",
      img: "https://img.icons8.com/ios-filled/100/4b5563/checklist.png",
      description: "Generate invoices, make adjustments, and view history.",
	  allowedEmails: ["jkaye@convalesceuk.com"]
    },
    
	
	
	
	
	
	
	
	
	
	
	
	
	
    {
      title: "Rota Creator & Editor",
      path: "/admin/rota",
      img: "https://img.icons8.com/ios-filled/100/f43f5e/planner.png",
      description: "Plan and update staff rotas efficiently."
    },
    {
      title: "User Management",
      path: "/admin/users",
      img: "https://img.icons8.com/ios-filled/100/4b5563/conference.png",
      description: "View, edit, or remove registered users."
    },
    {
      title: "Reports & Analytics",
      path: "/admin/reports",
      img: "https://img.icons8.com/ios-filled/100/4b5563/combo-chart.png",
      description: "Generate detailed reports and statistics."
    },
	
	{
	  title: "Support Plans",
	  path: "/admin/plans",
	  img: "https://img.icons8.com/ios-filled/100/f43f5e/invoice.png",
	  description: "View and edit client support and care plans."
	},
	
	
	{
	  title: "Client Management",
	  path: "/admin/clients",
	  img: "https://img.icons8.com/ios-filled/100/f43f5e/contacts.png",
	  description: "View and edit client list and details."
	}

  ];

  return (
    
	<  div style={{
    paddingTop: "90px",
     }}className="flex flex-col items-center p-6 space-y-4 text-gray-500">
	
	
	
      <h1 className="text-3xl  font-bold mb-8 text-gray-700">Admin Dashboard</h1>

      {/* 2 cards per row on medium screens and above */}
	  
      <div className="grid grid-cols-2 gap-4 sm:grid-cols-2 w-full max-w-md">
        {adminTools.map((tool) => (
          <Link
            key={tool.title}
            to={tool.path}
            className="bg-white shadow-md rounded-2xl p-6 hover:shadow-xl transition flex flex-col items-center text-center"
          >
            <img src={tool.img} alt={tool.title} className="w-12 h-12 mb-3" />
            <h2 className="text-lg font-semibold mb-2">{tool.title}</h2>
            <p className="text-sm text-gray-500">{tool.description}</p>
          </Link>
        ))}
      </div>
    </div>
  );
}
